<div class="page-wrap d-flex flex-row align-items-center"
    style="min-height:100vh;background-color:#3a5161;opacity:0.95">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-5 text-center card">
                <div [ngSwitch]="lastError" class="m-lg-4">
                    <div *ngSwitchCase="'invalidParams'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'INVALID-FHIR-LAUNCH', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'notTrustedIssuer'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'INVALID-FHIR-ISSUER', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'issuerDisabled'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'DISABLED-FHIR-ISSUER', class:'fa-exclamation-triangle icon-warn', issuerName: issuerName.issuer}">
                        </ng-template>
                    </div>
                    <div *ngSwitchCase="'unableToGetIssuer'" class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'FHIR-ISSUER-CHECK-ERROR', class:'fa-exclamation-triangle icon-warn'}">
                        </ng-template>
                    </div>
                    <div *ngSwitchDefault class="row mt-1">
                        <ng-template [ngTemplateOutlet]="statusTemplate"
                            [ngTemplateOutletContext]="{key: 'FHIR-AUTH', class:'fa-sign-in-alt'}">
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #statusTemplate let-key="key" let-class="class" let-issuerName="issuerName">
    <div class="col-1">
        <i class="fas {{class}} fa-2x"></i>
    </div>
    <div class="col-11">
        <span *ngIf="issuerName" [innerHTML]="(key | translate).replace('{{issuer}}',issuerName) | safe:'html'"
            class="montserrat">
        </span>
        <span *ngIf="!issuerName" [innerHTML]="key | translate | safe:'html'" class="montserrat"></span>
    </div>
</ng-template>